import { render, staticRenderFns } from "./ModalAlterarCartaoCobranca.vue?vue&type=template&id=5a29d4c0"
import script from "./ModalAlterarCartaoCobranca.vue?vue&type=script&lang=js"
export * from "./ModalAlterarCartaoCobranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports